var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 32.021C19.1667 32.021 18.4653 31.7293 17.896 31.146C17.3267 30.5627 17.042 29.8683 17.042 29.063C17.042 28.2297 17.3267 27.5143 17.896 26.917C18.4653 26.3197 19.1667 26.021 20 26.021C20.8333 26.021 21.5347 26.3197 22.104 26.917C22.6733 27.5143 22.958 28.2297 22.958 29.063C22.958 29.8683 22.6733 30.5627 22.104 31.146C21.5347 31.7293 20.8333 32.021 20 32.021ZM20 22.979C19.1667 22.979 18.4653 22.6943 17.896 22.125C17.3267 21.5557 17.042 20.8543 17.042 20.021C17.042 19.1877 17.3267 18.4863 17.896 17.917C18.4653 17.3477 19.1667 17.063 20 17.063C20.8333 17.063 21.5347 17.3477 22.104 17.917C22.6733 18.4863 22.958 19.1877 22.958 20.021C22.958 20.8543 22.6733 21.5557 22.104 22.125C21.5347 22.6943 20.8333 22.979 20 22.979ZM20 14.021C19.1667 14.021 18.4653 13.7223 17.896 13.125C17.3267 12.5277 17.042 11.8123 17.042 10.979C17.042 10.1457 17.3267 9.43734 17.896 8.854C18.4653 8.27067 19.1667 7.979 20 7.979C20.8333 7.979 21.5347 8.27067 22.104 8.854C22.6733 9.43734 22.958 10.1457 22.958 10.979C22.958 11.8123 22.6733 12.5277 22.104 13.125C21.5347 13.7223 20.8333 14.021 20 14.021Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.3c9024105786611237029a6d329ffea4.svg";
export { ForwardRef as ReactComponent };